/**
 * Creates a Promise that is resolved with an array of results when all
 * of the provided Promises resolve or reject.
 * @param {Promise[]} promises
 * @returns Promise
 */
function allSettled(promises) {
  const mappedPromises = promises.map((p) =>
    p
      .then((value) => ({
        status: 'fulfilled',
        value,
      }))
      .catch((reason) => ({
        status: 'rejected',
        reason,
      })),
  );
  return Promise.all(mappedPromises);
}

export default allSettled;
